import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/sql`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async sendRequest({commit}, payload) {
    const response = await axiosInstance.get(`${baseUrl}/${payload.type}`, {
        params: {
          companyId: payload.companyId,
          startDate: payload.startDate,
          endDate: payload.endDate,
        },
      })
    ;
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
